import { batches } from "@api/stores/products/batches/api";
import { bulkCreate } from "@api/stores/products/bulk/api";
import { prices } from "@api/stores/products/prices/api";
import { stats } from "@api/stores/products/stats/api";
import { createGetAllApi } from "@api/util/createGetAllApi";
import { createGetApi } from "@api/util/createGetApi";
import { createPatchApi } from "@api/util/createPatchApi";
import { createPostApi } from "@api/util/createPostApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam, IPathByIdParam } from "./path";
import type {
  IProductsDto,
  IProductsGetAllParams,
  IProductsResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IProductsResponse>>,
  IPathBaseParam,
  IPaginationParams & IProductsGetAllParams
>("stores.products");
const postApis = createPostApi<
  IApiResponse<IProductsResponse>,
  IPathBaseParam,
  IProductsDto
>("stores.products");
const getApis = createGetApi<
  IApiResponse<IProductsResponse>,
  IPathByIdParam,
  object
>("stores.products");
const patchApis = createPatchApi<
  IApiResponse<IProductsResponse>,
  IPathByIdParam,
  IProductsDto
>("stores.products");

export const products = {
  ...getAllApis,
  ...getApis,
  ...postApis,
  ...patchApis,
  stats,
  bulkCreate,
  batches,
  prices,
};
